import { Injectable } from '@angular/core';
import algoliasearch, { SearchIndex } from 'algoliasearch';
import { environment } from 'src/environments/environment';

@Injectable()
export class LookupService {
  private searchClient = algoliasearch(
    environment.algolia.appId,
    environment.algolia.apiKey
  );
  speciatlyBodyIndex: SearchIndex = this.searchClient.initIndex(environment.algolia.specialtyBodyIndex);
  specialtyMindIndex: SearchIndex = this.searchClient.initIndex(environment.algolia.specialtyMindIndex);
  conditionBodyIndex: SearchIndex = this.searchClient.initIndex(environment.algolia.conditionBodyIndex);
  conditionMindIndex: SearchIndex = this.searchClient.initIndex(environment.algolia.conditionMindIndex);
  professionalBodyIndex: SearchIndex = this.searchClient.initIndex(environment.algolia.professionalBodyIndex);
  accreditedRegistersIndex: SearchIndex = this.searchClient.initIndex(environment.algolia.accreditedRegistersIndex);

  constructor(){}

  searchSpecialties(category: string): Promise<string[]> {
    return new Promise<string[]>((resolve, reject) => {
      let index = category === 'body' ? this.speciatlyBodyIndex : this.specialtyMindIndex;
      index.search('', { hitsPerPage: 200 }).then(response => {
        let specialties: string[] = response.hits.map((s:any) => {
          return s.Name;
        });
        resolve(specialties);
      }, error => {
        reject(error);
      })
    });
  }

  searchConditions(category: string): Promise<string[]> {
    return new Promise<string[]>((resolve, reject) => {
      let index = category === 'body' ? this.conditionBodyIndex : this.conditionMindIndex;
      index.search('', {hitsPerPage: 300 }).then(response => {
        let conditions: string[] = response.hits.map((s:any) => {
          return s.Name;
        });
        resolve(conditions);
      }, error => {
        reject(error);
      })
    });
  }

  searchProfessionalBodies(): Promise<string[]> {
    return new Promise<string[]>((resolve, reject) => {
      this.professionalBodyIndex.search('', {hitsPerPage: 300 }).then(response => {
        let professionalBodies: string[] = response.hits.map((s:any) => {
          return s.Name;
        });
        resolve(professionalBodies);
      }, error => {
        reject(error);
      })
    });
  }

  searchAccreditedRegisters(): Promise<string[]> {
    return new Promise<string[]>((resolve, reject) => {
      this.accreditedRegistersIndex.search('', {hitsPerPage: 300 }).then(response => {
        let accreditedRegisters: string[] = response.hits.map((s:any) => {
          return s.Name;
        });
        resolve(accreditedRegisters);
      }, error => {
        reject(error);
      })
    });
  }
}
